import React from 'react';
import { CategoryFilterProps } from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilter.types';
import { Accordion, Typography } from '@drone-js/core';
import CategoryFilterItem from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilterItem';
import { CategoryId } from 'core/type/Category.types';
import { CmsProps } from 'core/type/BootstrapConfig.types';

const CategoryTitle: React.FC<CmsProps> = (props) => {
    return (
        <Typography data-testid="activities-categories-filter-heading" variant="heading-default" role="heading" aria-level={2}>
            {props.cms[252193]}
        </Typography>
    );
};
CategoryTitle.displayName = 'CategoryTitle';

const CategoryFilter: React.FC<CategoryFilterProps> = React.memo((props) => {
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value === '') {
            props.onCategoriesChange([], -1, -1);
            return;
        }
        const selectedItem = props.items.find((item) => item.values.includes(e.target.value as CategoryId));
        const selectedIndex = props.items.findIndex((item) => item.values.includes(e.target.value as CategoryId));

        if (selectedItem) {
            props.onCategoriesChange(selectedItem.values, selectedIndex, selectedItem.count);
        }
    };

    return (
        <Accordion data-testid="activities-categories-container" actionType="chevron-icon" contentSummary={<CategoryTitle cms={props.cms} />} level={3} view="expanded">
            {props.items.map((item, key) => (
                <CategoryFilterItem key={key} item={item} onCategoriesChange={onChangeHandler} index={key} />
            ))}
        </Accordion>
    );
});

CategoryFilter.displayName = 'CategoryFilter';

export default CategoryFilter;
